import { render, staticRenderFns } from "./StageNumberEdit.vue?vue&type=template&id=b1f4159c&scoped=true&"
import script from "./StageNumberEdit.vue?vue&type=script&lang=js&"
export * from "./StageNumberEdit.vue?vue&type=script&lang=js&"
import style0 from "./SalaryStage.css?vue&type=style&index=0&id=b1f4159c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f4159c",
  null
  
)

export default component.exports